// extracted by mini-css-extract-plugin
export default {"card":"Card_card__vOKjI","dummy":"Card_dummy__NR+EC"};